import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Component, Input, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { MatTabGroup } from '@angular/material/tabs';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';
import { PromotionsService } from '../../promotions.service';
import { DialogComponent } from 'src/app/features-common/components/dialog/dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { formatDate } from '@angular/common';
import createNumberMask from 'text-mask-addons/dist/createNumberMask'
import * as moment from 'moment';
import { JwtHelperService } from "@auth0/angular-jwt";
import { filter } from 'rxjs/internal/operators/filter';
import { HttpParams } from '@angular/common/http';
const helper = new JwtHelperService();
@Component({
  selector: 'app-edit-banner',
  templateUrl: './edit-banner.component.html',
  styleUrls: ['./edit-banner.component.scss']
})
export class EditBannerComponent extends FeaturesBaseComponent implements OnInit {
   bannerPromoForm: FormGroup;
  bannerPromoId: any;
  bannerPromoDetails: any;
  promotionsCarriers:any= [];
  skulist:any= [];
  productdetails: any;
  productName: string;
  userRole: string = "";
  readonly:boolean = false;
  promoResponseDetails: any;
  fileToUpload: File = null;
   fileuploaded: boolean=false;
  uploadpic: boolean;
  minDate :Date = new Date();
  // selectedImageName: string;
  profilePicPath: any;
  constructor(private activeRoute: ActivatedRoute,
    private router: Router, 
    public dialog: MatDialog,
    private promotionService: PromotionsService) {
    super();
    const token: string = localStorage.getItem("accessToken");
    let decoded_token: any = helper.decodeToken(token);
    this.userRole = decoded_token.role;
    this.bannerPromoId = this.activeRoute.snapshot.params.id;
    
    this.getAllBannersData()
  }
  getAllBannersData() {
    this.promotionService.getPromotionBanners().subscribe(res => {
      if (res['httpcode'] == 200) {
        this.promoResponseDetails=res.data
        this.bannerPromoDetails =  this.promoResponseDetails.find(d => d.promotionBannerId == this.bannerPromoId);
        this.profilePicPath = this.bannerPromoDetails?.promotionImageUrl;
        this.bannerPromoForm.get('promotionName').setValue(this.bannerPromoDetails.promotionName),
        this.bannerPromoForm.get('promitionDescription').setValue(this.bannerPromoDetails.promitionDescription),
        this.bannerPromoForm.get('promocodeStartDate').setValue(moment(this.bannerPromoDetails.promocodeStartDate).format()),
        this.bannerPromoForm.get('promocodeEndDate').setValue(moment(this.bannerPromoDetails.promocodeEndDate).format()),
        this.bannerPromoForm.get('promotionImageUrl').setValue(this.bannerPromoDetails.promotionImageUrl),
        this.bannerPromoForm.get('displayBanner').setValue(this.bannerPromoDetails.displayBanner=="Yes"?true:false)
      }
    })
  }
  handleFileInput(files: FileList) {
    this.fileToUpload = files.item(0);
    this.toastrService.info('Banner Image will reflect after saving changes', 'Info', {
      timeOut: 3000,
    });
    this.uploadpic = true;
   
    // this.selectedImageName = this.fileToUpload.name
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.initbannerPromoForm();
         
  }
  initbannerPromoForm(){
    this.bannerPromoForm = new FormGroup({
      promotionName: new FormControl('', [Validators.required]),
      promitionDescription: new FormControl('', [Validators.required]),
      promocodeStartDate: new FormControl(''),
      promocodeEndDate: new FormControl(''),
      promotionImageUrl:new FormControl(''),
      displayBanner: new FormControl(''),
      imagePreview: new FormControl('')

    })
  }
  get f(){
    return this.bannerPromoForm.controls;
  }

  ngOnDestroy():void{
    super.ngOnDestroy()
  }
 

  onBannerFormSubmit(e){
    if (this.bannerPromoForm.valid) {
      const dialogRef = this.dialog.open(DialogComponent, {
        data: {
          message: 'pages.placeholders.Areyousureyouwanttosavethechanges',
          buttonText: {
            ok: 'pages.placeholders.Save',
            cancel: 'pages.placeholders.cancel'
          }
        }
      });

      dialogRef.afterClosed().subscribe((confirmed: boolean) => {
        if (confirmed) {
          this.setSubmitParameters()
        }else{
          this.router.navigate(['features/promotions/banner-config/manage-banner'])
        }
      });

    }
  }
  setSubmitParameters(){  
    const formData: FormData = new FormData();
    formData.append('promotionBannerId', this.bannerPromoId);
    formData.append('promotionName', this.bannerPromoForm.get('promotionName').value);
    if (this.fileToUpload && this.fileToUpload){
      formData.append('promotionImage', this.fileToUpload)
    }else{
      formData.append('promotionImagePath', this.bannerPromoDetails.promotionImageUrl)
    }
    
    formData.append('promitionDescription', this.bannerPromoForm.get('promitionDescription').value);
    formData.append('promocodeStartDate', moment(this.bannerPromoForm.get('promocodeStartDate').value).format('YYYY/MM/DD'));
    formData.append('promocodeEndDate', moment(this.bannerPromoForm.get('promocodeEndDate').value).format('YYYY/MM/DD'));
    formData.append('displayBanner', this.bannerPromoForm.get('displayBanner').value==true ? 'Yes' : 'No');
    
    this.promotionService.updatePromotionBanners(formData).subscribe(
      res => {
        if (res && res) {
          if(res.httpcode == 200 && res.responseCodes.find(x => x == "TILA_101") || res.responseStatus == 'Success'){
            this.router.navigate(['features/promotions/banner-config/manage-banner'])
            this.toastrService.success('Promotion Banner updated successfully', 'Success', {
              timeOut: 3000,
            });        
        }
        }

      }
    );
  }
  onCancel() {
    const dialogRefCancel = this.dialog.open(DialogComponent, {
      
      data: {
        message: 'pages.placeholders.Areyousureyouwanttocancelthechanges',
        buttonText: {
          ok: 'pages.newRetailer.yes',
          cancel: 'pages.newRetailer.cancel'
        }
      }
    });

    dialogRefCancel.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.router.navigateByUrl('features/promotions/banner-config/manage-banner')
      }
    });
  }
  onCheckCertify(e){

    //alert(e.value)
  }

checkSubmitDisplayed() {
    return !(this.bannerPromoForm.valid && !this.bannerPromoForm.pristine); 
  }
}      

  